import { createFileRoute } from '@tanstack/react-router'
import { AccountingPage } from '@/features/accounting'

export const Route = createFileRoute('/_authenticated/deposits-personal/')({
  component: () => (
    <AccountingPage
      kind='deposits'
      accountType='personal'
      mode='operations'
      reviewPermission='deposit.personal.review'
      pageKey='personalOps'
    />
  ),
})
